import {BaseFragment} from "./BaseFragment";
import React from "react";
import {StyledBoxColumn, StyledEmpty} from "./StyledComponents";
import SadRobotImage from "./res/images/sadrobot.svg";
import {Action} from "./types";

export class StyledNotFoundFragment extends BaseFragment {

  render(): React.JSX.Element {
    return <StyledBoxColumn style={{flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
      <StyledEmpty
        emptyConfig={{
        iconUrl: SadRobotImage,
        title: "Not found",
        text: "This content may have been deleted, or you may not have the required permissions for access.",
        action: new Action("Go home", () => this.props.path.navigate("/")),
      }}
      imageStyle={{
        marginBottom: -48,
      }}/>
    </StyledBoxColumn>;
  }
}